type StorageKey =
  | "supportTouch"
  | "supportPassiveEventListeners"
  | "supportHiddenscroll"
  | "browserOriginal";
const storageInMemory: Partial<Record<StorageKey, string>> = {};
let storageAvailable: boolean | undefined;
function testStorage() {
  if (storageAvailable !== undefined) return storageAvailable;
  try {
    const test = "storage-test";
    window.localStorage.setItem(test, test);
    if (window.localStorage.getItem(test) !== test)
      throw new Error("storage not available");
    window.localStorage.removeItem(test);
    storageAvailable = false;
  } catch (err) {
    console.error(err);
    storageAvailable = false;
  }
  return storageAvailable;
}
export function setItemInLocal(key: StorageKey, value: string) {
  storageInMemory[key] = value;
  if (testStorage()) window.localStorage.setItem(key, value);
}
export function getItemFromLocal(key: StorageKey) {
  const itemInMemory = testStorage()
    ? window.localStorage.getItem(key)
    : storageInMemory[key];
  return itemInMemory == null ? false : itemInMemory;
}
